import app from "flarum/forum/app";
import Component from "flarum/common/Component";
import Button from "flarum/common/components/Button";
import Link from "flarum/common/components/Link";
import LoadingIndicator from "flarum/common/components/LoadingIndicator";
import FactFeedCard from "./FactFeedCard";
import FactEditor from "../../common/components/FactEditor";
import { invalidateFacts } from "../../common/components/FactList";
import { permitted, t } from "../../common/api";
import FactFeedState from "../states/FactFeedState";
export default class FactViewer extends Component {
  feed = (() => new FactFeedState())();
  active = 0;
  removed = false;
  ready = false;
  positioned = false;
  oninit(vnode) {
    super.oninit(vnode);
    void this.feed.init(this.attrs.id).then(() => {
      this.active = this.feed.startIndex;
      this.ready = !this.feed.failed;
      if (!this.removed) m.redraw();
    });
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.element.querySelector(".FactViewer-scroll")?.focus({
      preventScroll: true
    });
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    this.updateActive();
  }
  onremove(vnode) {
    this.removed = true;
    this.feed.remove();
    super.onremove(vnode);
  }
  updateActive() {
    if (!this.ready) return;
    const root = this.element.querySelector(".FactViewer-scroll");
    if (!root) return;
    const nodes = Array.from(root.querySelectorAll(".FactViewer-item"));
    if (!nodes.length) return;
    if (!this.positioned) {
      this.positioned = true;
      nodes[this.feed.startIndex]?.scrollIntoView({
        block: "start",
        behavior: "auto"
      });
      return;
    }
    const top = root.getBoundingClientRect().top;
    let nearest = 0;
    let distance = Infinity;
    nodes.forEach((node, i) => {
      const value = Math.abs(node.getBoundingClientRect().top - top);
      if (value < distance) {
        nearest = i;
        distance = value;
      }
    });
    if (this.active !== nearest) {
      this.active = nearest;
      m.redraw();
    }
    if (nodes.length && nearest >= nodes.length - 3 && !this.feed.failed && !this.feed.loading && this.feed.next !== null) void this.more();
  }
  async more() {
    if (!this.ready) {
      await this.feed.init(this.attrs.id);
      this.active = this.feed.startIndex;
      this.ready = !this.feed.failed;
    } else await this.feed.more();
    if (!this.removed) m.redraw();
  }
  move(delta) {
    const nodes = this.element.querySelectorAll(".FactViewer-item");
    const target = nodes[this.active + delta];
    if (target) target.scrollIntoView({
      block: "start",
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
    });
  }
  view() {
    return m("div", {
      className: "FactViewer"
    }, m("nav", {
      className: "FactViewer-toolbar",
      "aria-label": String(t("stories"))
    }, m(Link, {
      className: "Button Button--icon",
      href: app.route("index"),
      "aria-label": t("close_viewer")
    }, m("i", {
      className: "fas fa-times",
      "aria-hidden": "true"
    })), m("strong", null, t("stories")), m(Link, {
      className: "Button Button--text",
      href: app.route("xgayFactManage")
    }, t("manage")), permitted("canCreate") && m(Button, {
      className: "Button Button--icon",
      icon: "fas fa-pen",
      "aria-label": t("create"),
      onclick: () => app.modal.show(FactEditor, {
        onsaved: invalidateFacts
      })
    })), m("div", {
      className: "FactViewer-scroll",
      tabindex: 0,
      "aria-label": String(t("story_feed")),
      onscroll: event => {
        event.redraw = false;
        this.updateActive();
      },
      onkeydown: event => {
        if (event.target !== event.currentTarget) return;
        if (["ArrowDown", "PageDown", "ArrowUp", "PageUp"].includes(event.key)) {
          event.preventDefault();
          this.move(event.key === "ArrowDown" || event.key === "PageDown" ? 1 : -1);
        }
      }
    }, this.feed.stories.map((story, i) => m("section", {
      className: "FactViewer-item",
      key: story.id,
      "aria-label": story.author.name
    }, m(FactFeedCard, {
      story: story,
      active: this.ready && i === this.active
    }))), m("div", {
      className: "FactViewer-status",
      role: "status"
    }, this.feed.loading && m(LoadingIndicator, null), this.feed.missing && !this.feed.stories.length && m("p", null, t("unavailable")), this.feed.failed && m(Button, {
      className: "Button",
      onclick: () => this.more()
    }, t("retry")), !this.feed.loading && !this.feed.failed && this.feed.next === null && m("p", null, t(this.feed.stories.length ? "feed_end" : "empty")))), m("div", {
      className: "FactViewer-navigation"
    }, m(Button, {
      className: "Button Button--icon",
      icon: "fas fa-chevron-up",
      "aria-label": t("previous_story"),
      disabled: this.active === 0,
      onclick: () => this.move(-1)
    }), m(Button, {
      className: "Button Button--icon",
      icon: "fas fa-chevron-down",
      "aria-label": t("next_story"),
      disabled: this.active >= this.feed.stories.length - 1,
      onclick: () => this.move(1)
    })));
  }
}
flarum.reg.add('xgay-fact', 'forum/components/FactViewer', FactViewer);